import { Key } from "../libs/Core/Input/Key";

export const keyBinds = {
    pause: new Key(['p', 'P', 'Escape']),
    restart: new Key([' ']),
};